<template>
<div class="botaccount"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>



  
    <template >
      <v-toolbar flat>
        <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-twitter</v-icon>Bot Account</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex lg3>
          <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
        </v-flex>
        <!--v-dialog-->
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              outlined
              rounded
              small
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              >
              Add New Bot Account
              <v-icon class="ml-2">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
            <v-card-text style="height: 400px;" class="overflow-card">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field outlined dense v-model="iteminput.botacctid" label="Bot Account ID" 
                    hint="Input Bot Account ID" persistent-hint>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field outlined dense v-model="iteminput.botconsumerscret" label="Bot Consumer Secret" 
                    hint="Input Bot Consumer Secret" persistent-hint>
                    </v-text-field>
                  </v-col> 
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field outlined dense v-model="iteminput.botaccessscret" label="Bot Access Secret" 
                    hint="Input Bot Access Secret" persistent-hint>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field outlined dense v-model="iteminput.consumerkey" label="Bot Consumer Key" 
                    hint="Input Bot Consumer Key" persistent-hint>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field outlined dense  v-model="iteminput.botaccesstoken" label="Bot Access Token" 
                    hint="Input Bot Access Token" persistent-hint>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-select dense outlined :items="itemsactivate"  item-text="name_active" item-value="valueactive"  v-model="statusactive"  
                    hint="Activate/Disable crawling person by system" persistent-hint></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text> 

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>

              <v-divider class="mt-4" style=""></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-toolbar> 
    </template>


    <v-data-table
      :headers="headers"
      :items="botaccount"
      :search="search"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="botacctid"
      show-expand
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      >

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mx-2" small  @click="editItem(item.SEQ_ID)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item.SEQ_ID)">
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>

        <template v-slot:expanded-item="{ headers, item }" >
          <td :colspan="headers.length" elevation="0" class="pa-3 elevation-0">
            <p> CONSUMER KEY :  {{ item.BOT_CONSUMER_KEY }} </p>
            <p> CONSUMER SECRET :  {{ item.BOT_CONSUMER_SECRET }} </p>
            <p> ACCESS TOKEN : {{ item.BOT_ACCESS_TOKEN }} </p>
            <p> ACCESS SECRET :{{ item.BOT_ACCESS_SECRET }} </p>
          </td>
        </template>
      </v-data-table>
        <Notification  ref="alert"></Notification>
    </div>
</template>


<script>

import axios from "axios"
import Notification from  '@/components/Notification';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
        dialog: false, 
        dialogDelete: false,
        statusactive: 1,
        itemsactivate: [//choice select
          {valueactive: 1, name_active: "Enabled" },
          {valueactive: 0, name_active: "Disabled" }
        ],
        expanded: [],
        singleExpand: false,
        page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Crawling Engine',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Twitter',
          disabled: false,
          href: 'breadcrumbs_link_2',
        },
        {
          text: 'Bot Account',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      search:'',
      headers: [
        // { text: 'ID', value: 'SEQ_ID' },
        { text: 'BOT ACCT ID', value: 'BOT_ACCT_ID' },
        { text: 'STATUS', value: 'BOT_STATUS_TEXT' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'USERCREATE' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'USERUPDATE' },
        { text: 'Actions', value: 'actions' },
      ],
      
      botaccount: [],
      id_bot_account:"",
      bot_acct_id_before:"",
      status:"",
      iteminput: {
      },
      defaultItem: {
      },
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add Bot Account' : 'Edit Bot Account'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        axios.get("bot_account",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            console.log(response.data);
            this.botaccount = response.data;
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      deleteItem (item) {
        
        this.id_bot_account = item
        this.editedIndex = this.botaccount.indexOf(item)
        this.iteminput = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.botaccount.splice(this.editedIndex, 1)
        
        axios({
          method: "delete",
          url: "bot_account/delete",
          data: {
            id: this.id_bot_account
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          console.log(response);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.iteminput = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      editItem (item) {
        this.editedIndex = 1
        // this.editedIndex = this.botaccount.indexOf(item)
        this.iteminput = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "/bot_account_id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = response.data;
            this.id_bot_account = dat.SEQ_ID;
            this.bot_acct_id_before = dat.BOT_ACCT_ID;
            
            this.iteminput = {
              botacctid:dat.BOT_ACCT_ID,
              botconsumerscret:dat.BOT_CONSUMER_SECRET,
              consumerkey:dat.BOT_CONSUMER_KEY,
              botaccesstoken:dat.BOT_ACCESS_TOKEN,
              botaccessscret:dat.BOT_ACCESS_SECRET,
              // status_text:dat.BOT_STATUS_TEXT,
              // status:dat.BOT_STATUS,
            }
            
              this.statusactive=  dat.BOT_STATUS
            
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.botaccount[this.editedIndex], this.iteminput)
          axios.put("/bot_account/update", 
            {
              seq_id:this.id_bot_account,
              bot_acct_id:this.iteminput.botacctid,
              bot_acct_id_before:this.bot_acct_id_before,
              bot_cons_secret:this.iteminput.botconsumerscret,
              bot_cons_key:this.iteminput.consumerkey,
              bot_accs_token:this.iteminput.botaccesstoken,
              bot_accs_secret:this.iteminput.botaccessscret,
              bot_status:this.statusactive,
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              this.initialize();
              this.$router.push('/botaccount');
              // alert('okk');      
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        } 
        else {
          this.botaccount.push(this.iteminput)
          axios.post("/bot_account/insert", 
            {
              bot_acct_id:this.iteminput.botacctid,
              bot_cons_secret:this.iteminput.botconsumerscret,
              bot_cons_key:this.iteminput.consumerkey,
              bot_accs_token:this.iteminput.botaccesstoken,
              bot_accs_secret:this.iteminput.botaccessscret,
              bot_status:this.statusactive,
              
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            
              this.initialize();
              this.$router.push('/botaccount');
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        } 
        this.close();
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.iteminput = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>